import axios from 'axios';
import { API_URL, MANAGING_VESSEL_HISTORY_LOGS } from './ConstantService';

export const HistoryLogService = {
  async getAllManagingVesselHistoryLogs(page = 1, perPage = 30) {
    try {
      const response = await axios.get(`${API_URL}${MANAGING_VESSEL_HISTORY_LOGS}?page=${page}&per_page=${perPage}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return { error: true, data: error.response.data };
      }
      return { error: true, data: { message: 'Something went wrong' } };
    }
  },
};
